import type { VendingMachineLocation } from '~/contracts/vm';
import {
  LegendLocationItem,
  LegendLocationItemAddress,
  LegendLocationItemDistance,
  LegendLocationItemInnerContainer,
  LegendLocationItemTitle,
  LegendLocations,
  MapLegendListContainer
} from './MapLegend.styles';

type LocationWithDistance = VendingMachineLocation & {
  distance?: {
    hasError: boolean;
    mi: number;
  };
};

type MapLegendProps = {
  activeLocation: {
    label: string;
  };
  map: google.maps.Map;
  updateActiveLocation: (
    location: LocationWithDistance | { label: string }
  ) => void;
  vendingMachineLocations: LocationWithDistance[];
};

const locationItemClick =
  (
    map: google.maps.Map,
    location: LocationWithDistance,
    updateActiveLocation: MapLegendProps['updateActiveLocation']
  ) =>
  () => {
    updateActiveLocation(location);

    const z = map.getZoom() ?? 0;

    if (z > 4.7) {
      map.setZoom(4.7);
    }

    setTimeout(() => {
      map.panTo({ lat: location.lat, lng: location.lng });
      map.setZoom(8);
    }, 800);

    setTimeout(() => updateActiveLocation({ label: '' }), 0);
  };

const makeHref = (location: LocationWithDistance): string => {
  const city = location.alias?.city ?? location.city;
  const state = location.alias?.state ?? location.state;
  const href = `/vending-machine/${city.replace(' ', '-')}-${state}`;

  return href;
};

export const MapLegend = ({
  activeLocation,
  map,
  updateActiveLocation,
  vendingMachineLocations
}: MapLegendProps) => {
  return (
    <MapLegendListContainer>
      <LegendLocations>
        {vendingMachineLocations.map((location, i) => (
          <LegendLocationItem
            data-analytics-id="Location Item"
            element="div"
            isActive={location.label === activeLocation.label}
            key={i}
            onClick={locationItemClick(map, location, updateActiveLocation)}
          >
            <LegendLocationItemInnerContainer>
              <a href={makeHref(location)} data-analytics-id={null}>
                <LegendLocationItemTitle>
                  {i + 1}. {location.label}
                </LegendLocationItemTitle>
              </a>
              <LegendLocationItemDistance>
                {location.distance && !location.distance.hasError
                  ? `${location.distance.mi.toFixed(0)} mi`
                  : ''}
              </LegendLocationItemDistance>
              <LegendLocationItemAddress>
                {location.address}
              </LegendLocationItemAddress>
              <LegendLocationItemAddress>
                {`${location.city}, ${location.state}  ${location.zip}`}
              </LegendLocationItemAddress>
            </LegendLocationItemInnerContainer>
          </LegendLocationItem>
        ))}
      </LegendLocations>
    </MapLegendListContainer>
  );
};
